// index.js

import { combineReducers } from 'redux';

import s3Templates from './s3Templates';
import buy from './buy';
import uploads from './uploads';
import users from './users';
import userImages from './s3UserImages';
import receipts from './receipts';
import paypal from './paypal';
import modal from './modal';

export default combineReducers({
  s3Templates,
  buy,
  uploads,
  users,
  userImages,
  receipts,
  paypal,
  modal
});



// WEBPACK FOOTER //
// ./src/store/reducers/index.js